//
//
//
//
//
//
//
//
//
//

import ProductCard from "./products/ProductCard";

export default {

  props: {
    section: {
      type: Object,
      default: () => {
        return {}
      }
    },
    content: {
      type: Array,
      required: true,
      default () {
        return []
      }
    },
    activeCategory: {
      type: String,
      reuqired: false,
      default () {
        return ''
      }
    }
  },

  components: {
    ProductCard
  }

}
